<template>
    <div id="accumulated_precp" 
        class="popup-table popup-table--full-width"
    >
        <v-card 
            class="popup-table__wrapper" 
            style="min-height: 0;"
        >
            <div class="popup-table__container">
                <div class="popup-table__container-title">
                    <div class="d-flex justify-space-between align-center">
                        <h1>自選時段累積雨量</h1>
                        <div>
                            <v-btn
                                class="back-station-title__btn"
                                color="white"
                                icon
                                @click="is_minimize=!is_minimize"
                            >
                                <v-icon color="white">
                                    {{ is_minimize ? 'mdi-window-maximize' : 'mdi-window-minimize' }}
                                </v-icon>
                            </v-btn>
                            <v-btn
                                class="back-station-title__btn"
                                color="white"
                                icon
                                @click="is_table_expand=!is_table_expand"
                            >
                                <v-icon color="white">
                                    {{ is_table_expand ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                </v-icon>
                            </v-btn>
                            <v-btn
                                class="back-station-title__btn"
                                color="white"
                                icon
                                @click="close_accu_precp"
                            >
                                <v-icon color="white">
                                    icon-close
                                </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="control-options"
                :class="{'minimize': is_minimize, 'custom': is_custom}"
            >
                <div class="control-options__setting flex-gap">
                    <div class="control-options__time-setting">
                        <div class="control-options__item">
                            <span class="control-options__item-hint">起始日期</span>
                            <v-select
                                :items="dates"
                                v-model="selected_start_date"
                                class="control-options__item-select"
                                dense
                                hide-details
                            />
                        </div>
                        <div class="control-options__item">
                            <span class="control-options__item-hint">起始時間</span>
                            <v-select
                                :items="start_hours"
                                v-model="selected_start_hour"
                                dense
                                hide-details
                            />
                        </div>
                        <p class="control-options__dash" />
                        <div class="control-options__item">
                            <span class="control-options__item-hint">結束日期</span>
                            <v-select
                                :items="dates"
                                v-model="selected_end_date"
                                hide-details
                                dense
                            />
                        </div>
                        <div class="control-options__item">
                            <span class="control-options__item-hint">結束時間</span>
                            <v-select
                                :items="end_hours"
                                v-model="selected_end_hour"
                                hide-details
                                dense
                            />
                        </div>
                        <div v-if="!is_custom"
                            class="control-options__item control-options__item--no-hint"
                        >
                            <v-select
                                background-color="lightcoral"
                                :items="counties_list"
                                v-model="county_selected"
                                hide-details
                            />
                        </div> 
                        <div v-if="!is_custom"
                            class="control-options__item control-options__item--no-hint"
                        >
                            <v-select
                                background-color="lightcoral"
                                :items="towns_list"
                                v-model="town_selected"
                                hide-details
                            />
                        </div>
                        <div
                            class="control-options__item control-options__time"
                            :class="{
                                'control-options__time--active': has_time_setting_error
                            }"
                        >
                            <span>結束時間</span>
                            <span>小於</span>
                            <span>起始時間</span>
                        </div>
                    </div>

                    <div v-if="is_custom"
                        class="control-options__custom flex-gap"
                    >
                        <div class="control-options__select flex-gap">
                            <v-radio-group v-model="current_select"
                                hide-details
                            >
                                <v-radio
                                    value="tag"
                                />
                            </v-radio-group>
                            <div class="control-options__item control-options__item--no-hint">
                                <v-select
                                    background-color="lightcoral"
                                    :items="tag_list_rainstation"
                                    v-model="selected_tag"
                                    hide-details
                                    return-object
                                    item-text="tag_name"
                                    item-value="tag_id"
                                />
                            </div>
                        </div>
                        <div class="control-options__select flex-gap">
                            <v-radio-group v-model="current_select"
                                hide-details
                            >
                                <v-radio
                                    value="county"
                                />
                            </v-radio-group>
                            <div class="control-options__item control-options__item--no-hint">
                                <v-select
                                    background-color="lightcoral"
                                    :items="counties_list"
                                    v-model="county_selected"
                                    hide-details
                                />
                            </div> 
                            <div class="control-options__item control-options__item--no-hint">
                                <v-select
                                    background-color="lightcoral"
                                    :items="towns_list"
                                    v-model="town_selected"
                                    hide-details
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="control-options__btn-wrapper">
                    <button
                        class="control-options__btn"
                        :class="{
                            'control-options__btn--disabled': has_time_setting_error
                        }"
                        @click="get_accu_precp_data"
                    >
                        查詢
                    </button>
                </div>
            </div>

            <div class="accumulated-precp__table-container"
                :class="{'expand': is_table_expand, 'minimize': is_minimize}"
            >
                <QpeDatatable v-if="show_table"
                    class="accumulated-precp__table-content"
                    :data="table_data"
                    :headers="header"
                    :show_datetime="false"
                    :show_search_bar="false"
                    :show_footer="true"
                    header_background_color="#e8ecf7"
                    header_text_color="black"
                    table_page_component_id="accumulated_precp"
                    :show_description_dialog_btn="false"
                    :show_download_pdf_btn="true"
                    table_text_for_download_pdf="自選時段累積雨量"
                />
            </div>            
        </v-card>
    </div>
</template>

<script>
    import {
        accumulated_precp_table_ajax, 
        accumulated_precp_csv_ajax,
        tag_list_rainstation_ajax
    } from "@/utils/emap/accumulated_precp.js"
    import { get_remote_file_ajax } from "@/utils/emap/emap_init.js"
    import { table_title_accumulated_precp, town_list_file } from '@/config/accumulated_precp_config.js'
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import QpeDatatable from "../monitor/qpe_datatable.vue"

    export default {
        name: 'AccumulatedPrecp',
        
        components: { QpeDatatable },
        
        data() {
            return {
                dates: [],
                selected_start_date: '',
                selected_end_date: '',
                selected_start_hour: '00時',
                selected_end_hour: '00時',
                end_time: '',

                town_data: {},
                county_selected: '',
                town_selected: '',
                
                original_table_data: [],
                original_header: [],
                header: [],
                
                show_table: false,
                
                file_path: '',

                is_table_expand: false,
                is_minimize: false,

                // 客製化表格
                tag_list_rainstation: [],
                current_select: 'tag',
                selected_tag: {},
                custom_data: {
                    header: {},
                    table: {}
                }
            }
        },

        computed: {
            ...mapState([
                'client_name',
            ]),

            ...mapState('emap', [
                'selected_timeless_item_id'
            ]),

            ...mapState('case', [
                'case_selected'
            ]),

            ...mapGetters('emap', [
                'map_status'
            ]),

            counties_list() {
                if (!Object.keys(this.town_data).length) return []

                return [
                    '全縣市',
                    ...Object.keys(this.town_data)
                ]
            },

            towns_list() {
                if (!Object.keys(this.town_data).length) return []

                if (this.county_selected === '全縣市') {
                    const all_towns = Object.values(this.town_data).reduce((accumulator, towns) => {
                        const towns_list = towns.reduce((accumulator_town, { name }) => [...accumulator_town, name] ,[])
                        return [
                            ...accumulator,
                            ...towns_list
                        ]
                    }, [])
                    return  [ 
                        '全鄉鎮',
                        ...all_towns
                    ]    
                }

                return  [ 
                    '全鄉鎮',
                    ...this.town_data[this.county_selected].map(({ name }) => name)
                ]
            },

            start_hours() {
                let first_hour = 0;
                if (this.selected_start_date == this.dates[0]) {
                    first_hour = this.is_case ? 0 : new Date().getHours();
                }
                return [...Array(24 - first_hour)].map((item, index) => {
                    const current_hour = first_hour + index
                    return `${this._fillzero(current_hour)}:00`
                })
            },

            end_hours() {
                let latest_hour = 23;
                if (this.selected_end_date == this.dates[this.dates.length-1]) {
                    latest_hour = this.is_case ? 0 : new Date().getHours();
                }

                return [...Array(latest_hour + 1)].map((item, index) => {
                    const current_hour = index
                    return `${this._fillzero(current_hour)}:00`
                })
            },

            has_time_setting_error() {
                const start_time = new Date(this._get_completed_datetime(this.selected_start_date, this.selected_start_hour));
                const end_time = new Date(this._get_completed_datetime(this.selected_end_date, this.selected_end_hour));
                return end_time <= start_time
            },

            table_data() {
                const county_filter_text = this.county_selected === '全縣市' ? '' : this.county_selected
                const town_filter_text = this.town_selected === '全鄉鎮' ? '' : this.town_selected
                const tag_text = this.selected_tag.tag_name;

                // TODO 有了客製化表格以後，轉成鄉鎮會出錯，要重新判斷過
                return this.is_use_custom_data ? this.custom_data.table[tag_text] : this.original_table_data.filter((table_datum) => {
                    return (
                        table_datum['縣市'].includes(county_filter_text) && 
                        table_datum['鄉鎮'].includes(town_filter_text)
                    )
                })
            },

            is_custom() {
                return this.tag_list_rainstation.length;
            },

            is_use_custom_data() {
                return this.is_custom && this.current_select === 'tag';
            },

            // 這邊需要特別注意，個案給的會是 UTC+0 的時間；需轉換為台灣 UTC+8
            // 個案給的時間戳記都是字串
            case_start_date() {
                const date = new Date(Number(this.case_selected.start));
                date.setHours(date.getHours() + 8);
                return date;
            },

            case_end_date() {
                const date = new Date(Number(this.case_selected.end));
                date.setHours(date.getHours() + 8);
                date.setDate(date.getDate() + 1);
                return date;
            },

            is_case() {
                return this.map_status === 'case';
            }
        },

        watch: {
            map_status() {
                this.change_time();
            },

            case_selected() {
                this.change_time();
            },

            counties_list() {
                if (!this.county_selected) {
                    this.county_selected = this.counties_list[0]
                }
            },

            towns_list() {
                this.town_selected = this.towns_list[0]
            },

            start_hours() {
                const current_hour = this.is_case ? 0 : new Date().getHours();
                this.selected_start_hour = `${this._fillzero(current_hour)}:00`;
            },

            end_hours() {
                const current_hour = this.is_case ? 0 : new Date().getHours();
                this.selected_end_hour = `${this._fillzero(current_hour)}:00`;
            },

            selected_timeless_item_id() {
                !this.selected_timeless_item_id && this.set_accumulated_precp({
                    start_time: '',
                    end_time: ''
                })
            },

            current_select() {
                // 讓轉圈圈 loading 再出來
                this.header = []
                this.original_table_data = []
                this.show_table = false;
            },

            selected_tag: {
                deep: true,
                handler() {
                    this.header = this.custom_data.header[this.selected_tag.tag_name] || [];
                }
            }
        },

        created() {
            this.generate_dates();
            this.init_county_town_options();
            this.init_tag_list_rainstation();
        },

        methods: {
            ...mapMutations('emap', [
                'set_is_show_accumulated_precp_table',
                'set_accumulated_precp',
                'set_selected_products',
            ]),

            change_time() {
                if (this.is_case) {
                    const range =  this.case_end_date.getDate() - this.case_start_date.getDate() + 1;
                    this.generate_dates(this.case_end_date, range);
                } else {
                    this.generate_dates();
                }
            },

            async init_tag_list_rainstation() {
                const res = await tag_list_rainstation_ajax(this.client_name);
                if (res.data.status !== 'success') return console.error('tag_list_rainstation init error');
                this.tag_list_rainstation = res.data.data;
                this.selected_tag = this.tag_list_rainstation[0] || {};
            },

            generate_dates(end_date, range) {
                const All_OPTIONS_COUNT = range || 10;
                this.dates = [...Array(All_OPTIONS_COUNT)].map((item, index) => {
                    const minus_date = All_OPTIONS_COUNT - 1 - index

                    let d;
                    if (typeof end_date === 'undefined') {
                        d = new Date(+new Date() + 8* 3600000);
                    } else {
                        d = new Date(end_date);
                    }
                    d.setDate(d.getDate() - minus_date);

                    return d.toISOString().substring(0, 10);
                })

                this.selected_start_date = this.dates[All_OPTIONS_COUNT-2];
                this.selected_end_date = this.dates[All_OPTIONS_COUNT-1];
            },

            async init_county_town_options() {
                const res = await get_remote_file_ajax(town_list_file)
                this.town_data = res.data
            },

            async get_accu_precp_data() {
                // 讓轉圈圈 loading 再出來
                this.header = []
                this.original_table_data = []

                if(!this.has_time_setting_error) {
                    this.show_table = true;
                    const start_time = this._get_completed_datetime(this.selected_start_date, this.selected_start_hour);
                    const end_time = this._get_completed_datetime(this.selected_end_date, this.selected_end_hour);
                    
                    const basic_params = {
                        county : this.county_selected, 
                        start_time,  
                        end_time
                    }
                    
                    if (this.is_use_custom_data) {
                        basic_params.tag_id = this.selected_tag.tag_id;
                    }

                    const res = await accumulated_precp_table_ajax(this.client_name, {
                        ...basic_params, 
                        county : this.county_selected
                    });
                    this.construct_table(res.data.data);
                    this.file_path = res.data.file

                    const csv_res = await accumulated_precp_csv_ajax(this.client_name, {
                        ...basic_params, 
                        file : this.file_path
                    });
                    this.construct_map(csv_res.data.data) 
                    
                    this.set_accumulated_precp({
                        start_time: `${this.selected_start_date} ${this.selected_start_hour.substring(0, 2)}:00`,
                        end_time: `${this.selected_end_date} ${this.selected_end_hour.substring(0, 2)}:00`
                    })
                }
                else {
                    this.show_table = false;
                }
            },

            construct_table(data) {
                if (this.is_use_custom_data) return this.custom_table(data);

                this.original_header = table_title_accumulated_precp.map((name, index) => {
                    return {'text': name, 'value': name, 'order': index}
                });
                this.header = this.original_header;
                this.original_table_data = Object.entries(data).reduce((accumulator, [city, table_data_group_by_city]) => {
                    const county_data_list = table_data_group_by_city.map((county_data) => {
                        return { 
                            ...county_data, 
                            '縣市': city
                        }
                    })
                    
                    return [...accumulator, ...county_data_list]
                }, [])
            },

            custom_table(data) {
                const current_table = data[this.selected_tag.tag_name];
                const tag_keys = Object.keys(data);
                if (current_table.length) {
                    tag_keys.forEach( item => {
                        this.$set(this.custom_data.header, item, Object.keys(data[item][0]).map((name, index) => {
                            return {'text': name, 'value': name, 'order': index}
                        }));
                        this.$set(this.custom_data.table, item, data[item]);
                    });

                    this.header = this.custom_data.header[this.selected_tag.tag_name];
                } else {
                    this.show_table = false;
                    console.error('客製化累積雨量表格無資料');
                }
            },

            construct_map(precp_data) {
                const layer1_name = precp_data['data_category']
                const layer2_name = precp_data['data_source']
                const custom = {
                    'name': layer2_name, 
                    'node':false, 
                    'type': 'checkbox', 
                    'radio_name': layer1_name, 
                    'index': 0, 
                    'path_name': `accumlated_precp/${layer1_name}/${layer2_name}`
                };
                const completed_precp_data = [{...custom, ...precp_data}]

                this.set_selected_products(completed_precp_data)
            },

            _fillzero(s) {
                let r = String(s);
                if (r.length < 2)
                    return "0" + r;
                
                return r;
            },

            _get_completed_datetime(date, hour) {
                return `${date} ${hour.substring(0, 2)}:00:00`
            },

            close_accu_precp() {
                this.set_is_show_accumulated_precp_table(false)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin';
    @import '../../../css/emap/gis/popup';

    .popup-table {
        position: absolute;
        bottom: 0;
        z-index: 4003;

        &__wrapper {
            background: #fff !important;
        }
    }

    .control-options {
        display: flex;
        gap: 1rem;
        margin: .5rem 1rem;

        @include tablet {
            display: block;
        }

        &__item {
            &-hint {
                font-size: 12px;
                letter-spacing: .5px;
                line-height: 1.33;
                color: var(--base-gray);
            }

            &--no-hint {
                margin-top: .75rem;
            }
        }

        &__dash {
            margin: 1rem;

            @include tablet {
                display: none;
            }

            &::before {
                content: '';
                display: inline-block;
                width: .5rem;
                height: .125rem;
                background-color: #b3b7c4;
            }
        }

        &__time {
            display: flex;
            flex-direction: column;
            min-width: 4rem;
            font-size: .9rem;
            color: var(--base-red);
            visibility: hidden;

            @include tablet {
                flex-direction: row;
                flex-wrap: wrap;
                align-items: flex-end;
            }

            &--active {
                visibility: visible;
            }
        }

        &__btn {
            display: flex;
            align-items: center;
            justify-content: center;
            // margin-top: 1.75rem;
            padding: 1rem;
            width: 8rem;
            height: 2rem;
            color: #fff;
            background-color: var(--base-blue);
            border-radius: 1rem;
            cursor: pointer;

            @include tablet {
                margin-top: 0;
            }

            &-wrapper {
                display: flex;
                justify-content: flex-end;
            }
        }

        .flex-gap {
            display: flex;
            gap: 1rem;
        }

        &__setting {

            @include tablet {
                display: block;
            }
        }

        &__time-setting {
            display: flex;
            gap: 1rem;
            align-items: flex-end;

            @include tablet {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                width: 100%;
            }
        }

        &__select {
            .control-options__item {
                width: 200px;

                @include mobile {
                    width: 140px;
                }
            }
        }

        &__custom {
            @include tablet {
                width: 100%;
                flex-wrap: wrap;
                margin-bottom: 1rem;
            }
        }
    }

    .custom.control-options {
        align-items: center;
        
        .control-options__setting {
            flex-wrap: wrap;
        }
    }

    ::v-deep .control-options {
        &__select .v-radio {
            margin: 0;
        }

        .v-text-field,.control-options__item--no-hint,.v-input--selection-controls {
            margin-top: 0;
            padding-top: 0;
        }
    }

    .accumulated-precp__table {
        &-container {
            overflow: auto;
            height: 45vh;
            background: #fff;
        }

        &-content {
            overflow: auto;
        }
    }
    .popup-table__wrapper {
        display: flex;
        flex-direction: column;
    }

    .popup-table__wrapper .accumulated-precp__table-container {
        height: calc(50vh - 200px);
    }

    .popup-table__wrapper .accumulated-precp__table-container.expand {
        height: calc(100vh - 200px);

        @include tablet {
            height: calc(100vh - 400px);
        }
    }

    .popup-table__wrapper .accumulated-precp__table-container, .control-options {
        &.minimize {
            display: none;
        }
    }
</style>